import KitneticLogo from '@/assets/branding/kitnetic/KiTNETiC_Logo.png';

export default {
  name: 'KiTNETiC',
  isSAML: true,
  allowPersonalCourses: false,
  logo: KitneticLogo,
  colors: {
    // Brand colors
    brand_primary: '#CE79E7',
    brand_primary_hover: '#B45ACF', // −10 L, −8 S
    brand_primary_highlight: '#E7B5F4', // +23 L, +7 S
    brand_primary_mid: '#D48AEF', // +8 L,  +2 S
    brand_primary_dark: '#7A2D99', // −25 L, −3 S (clamped)
    // Use one of the additional brand colors as a secondary/accent
    brand_secondary: '#FF66C4', // pink accent, roughly hue +4°, −15 L, −13 S from primary
  },
};
